import pick from 'lodash/pick';

import config from '../../config';
import { initiateMultiPrivileged } from '../../util/api';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';

import * as log from '../../util/log';
import {
  fetchCurrentUserHasOrdersSuccess,
  fetchCurrentUser,
  getUserToken,
  refreshCartMaybe,
} from '../../ducks/user.duck';
import { requestAction } from '../../util/eventsHelpers/constants';
import { sendEventByAction } from '../../util/eventsHelpers';
import { maskContactDetails } from '../../util/contactDetails';
import {forEach, pathOr} from 'ramda';
import {updateProfile} from "../ProfileSettingsPage/ProfileSettingsPage.duck";

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/CheckoutPageMultiBooking/SET_INITIAL_VALUES';

export const INITIATE_MULTI_BOOKING_REQUEST = 'app/CheckoutPageMultiBooking/INITIATE_MULTI_BOOKING_REQUEST';
export const INITIATE_MULTI_BOOKING_SUCCESS = 'app/CheckoutPageMultiBooking/INITIATE_MULTI_BOOKING_SUCCESS';
export const INITIATE_MULTI_BOOKING_ERROR = 'app/CheckoutPageMultiBooking/INITIATE_MULTI_BOOKING_ERROR';

// ================ Reducer ================ //

const initialState = {
  listing: null,
  bookingData: null,
  bookingDates: null,
  transaction: null,
  initiateOrderError: null,
  isLoading: false,
};

export default function CheckoutPageMultiBookingReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case INITIATE_MULTI_BOOKING_REQUEST:
      return { ...state, initiateOrderError: null, isLoading: true };
    case INITIATE_MULTI_BOOKING_SUCCESS:
      return { ...state, transaction: payload, isLoading: false };
    case INITIATE_MULTI_BOOKING_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, initiateOrderError: payload, isLoading: false };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const initiateMultiBookingRequest = () => ({ type: INITIATE_MULTI_BOOKING_REQUEST });

const initiateMultiBookingSuccess = order => ({
  type: INITIATE_MULTI_BOOKING_SUCCESS,
  payload: order,
});

const initiateMultiBookingError = e => ({
  type: INITIATE_MULTI_BOOKING_ERROR,
  error: true,
  payload: e,
});

/* ================ Thunks ================ */

export const initiateMultiBooking = (orderParams, message) => (dispatch, getState, sdk) => {
  dispatch(initiateMultiBookingRequest());
  const bodyParams = orderParams;
  const queryParams = {
    include: ['booking', 'provider'],
    expand: true,
  };
  const state = getState();
  const discount = pathOr(null, ['CheckoutPage', 'discount', 'discount'], state);
  const token = getUserToken();
  const handleSuccess = response => {
    console.log('response', response);
    const {data = []} = response;
    forEach(tx => {
      dispatch(sendMessage({message, id: tx.booking.data.id.uuid}));
    }, data);
    const entities = denormalisedResponseEntities(response);
    const order = entities[0];
    dispatch(initiateMultiBookingSuccess(order));
    dispatch(fetchCurrentUserHasOrdersSuccess(true));
    dispatch(updateProfile({
      publicData: {
        paymentMethodVerified: true,
      },
    }));
    // dispatch(refreshCartMaybe(null, {
    //   bookingSearchId,
    //   bookingParams: getBookingParams(bookingDateMaybe)
    // }));
    return order;
  };

  const handleError = e => {
    dispatch(initiateMultiBookingError(storableError(e)));
    log.error(e, 'initiate-order-failed', {
      listingId: orderParams.listingId.uuid,
      bookingStart: orderParams.bookingStart,
      bookingEnd: orderParams.bookingEnd,
    });
    throw e;
  };

  return initiateMultiPrivileged({ isSpeculative: false, bodyParams, queryParams, discount }, token)
    .then(handleSuccess)
    .catch(handleError);
};

export const sendMessage = params => (dispatch, getState, sdk) => {
  const message = params.message && maskContactDetails(params.message.trim());
  const orderId = params.id;

  if (message) {
    return sdk.messages
      .send({ transactionId: orderId, content: message })
      .then(() => {
        // sendEventByAction(orderId.uuid, requestAction);
        return { orderId, messageSuccess: true };
      })
      .catch(e => {
        log.error(e, 'initial-message-send-failed', { txId: orderId });
        return { orderId, messageSuccess: false };
      });
  } else {
    return Promise.resolve({ orderId, messageSuccess: true });
  }
};

export const loadData = () => {
  return fetchCurrentUser();
};
